(function () {
    "use strict";
  
    var CONFIG = {
      DEBUG: false,
      ROOT_ID: "bsi29-root",
      HIDE_SELECTORS: [".cart-delivery-title"]
    };
  
    var WD = ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."];
    var STOCK_TRIM = /\s*[-–—]\s*in\s+[\d\-–—]+\s*Werktagen\s*bei\s*dir\s*/i;
    var PARCEL_SVG =
      '<svg class="bsi29-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M21 8.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8.5M21 8.5l-1.4-4.2A1 1 0 0 0 18.7 3.5H5.3a1 1 0 0 0-.9.8L3 8.5M21 8.5H3M7 11.5h.01M11 11.5h.01" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M9 3.5V8.5h6V3.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg>";
  
    var activeRoot = null;
    var tickTimer = null;
    var hideObserver = null;
    var navObserver = null;
    var lastEarliest = "";
    var lastLatest = "";
  
    function log() {
      if (CONFIG.DEBUG) console.log.apply(console, ["[BSI-0029]"].concat([].slice.call(arguments)));
    }
  
    /** Parse "Lieferung in 5-8 Werktagen" / "2 - 5" → { min, max }. */
    function parseDeliveryRange(text) {
      var m = String(text || "").match(/(\d+)\s*[-–—]\s*(\d+)/);
      if (!m) return null;
      var a = parseInt(m[1], 10);
      var b = parseInt(m[2], 10);
      if (!a || !b) return null;
      return { min: Math.min(a, b), max: Math.max(a, b) };
    }

    function ruleFromRoot(root) {
      var min = parseInt(root.dataset.min, 10);
      var max = parseInt(root.dataset.max, 10);

      // Product Delivery Time block text overrides data-min / data-max.
      var deliveryEl = document.querySelector(".product-delivery-time_main_wrap");
      var parsed = parseDeliveryRange(deliveryEl && deliveryEl.textContent);

      if (parsed) {
        min = parsed.min;
        max = parsed.max;
      }

      return {
        cutoff: parseInt(root.dataset.cutoff, 10),
        min: min,
        max: max
      };
    }
  
    function berlinNow() {
      return new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" }));
    }
  
    /** Anonymous Gregorian algorithm → Easter Sunday for year y (local date parts). */
    function easterSunday(y) {
      var a = y % 19;
      var b = Math.floor(y / 100);
      var c = y % 100;
      var d = Math.floor(b / 4);
      var e = b % 4;
      var f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4);
      var k = c % 4;
      var l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31);
      var day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(y, month - 1, day);
    }
  
    function ymdKey(d) {
      return (
        d.getFullYear() +
        "-" +
        ("0" + (d.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + d.getDate()).slice(-2)
      );
    }
  
    /**
     * Bavarian gesetzliche Feiertage (statewide).
     * Includes Mariä Himmelfahrt (15.08); excludes Augsburg-only Friedensfest (08.08).
     */
    function isBavarianHoliday(d) {
      var y = d.getFullYear();
      var key = ymdKey(d);
      var fixed = [
        y + "-01-01",
        y + "-01-06",
        y + "-05-01",
        y + "-08-15",
        y + "-10-03",
        y + "-11-01",
        y + "-12-25",
        y + "-12-26"
      ];
      if (fixed.indexOf(key) !== -1) return true;
  
      var easter = easterSunday(y);
      var movableOffsets = [-2, 1, 39, 50, 60]; // Karfreitag, Ostermontag, Himmelfahrt, Pfingstmontag, Fronleichnam
      for (var i = 0; i < movableOffsets.length; i++) {
        var md = new Date(easter);
        md.setDate(easter.getDate() + movableOffsets[i]);
        if (ymdKey(md) === key) return true;
      }
      return false;
    }
  
    function isBiz(d) {
      var g = d.getDay();
      if (g === 0 || g === 6) return false;
      return !isBavarianHoliday(d);
    }
  
    function addBiz(d, n) {
      var r = new Date(d);
      var a = 0;
      while (a < n) {
        r.setDate(r.getDate() + 1);
        if (isBiz(r)) a++;
      }
      return r;
    }
  
    function nextBiz(d) {
      var r = new Date(d);
      do {
        r.setDate(r.getDate() + 1);
      } while (!isBiz(r));
      return r;
    }
  
    function compute(rule) {
      var now = berlinNow();
      var cutoff = new Date(now);
      cutoff.setHours(rule.cutoff, 0, 0, 0);
      var beforeCutoff = isBiz(now) && now < cutoff;
      var ship = beforeCutoff ? new Date(now) : nextBiz(now);
      ship.setHours(0, 0, 0, 0);
      return {
        beforeCutoff: beforeCutoff,
        cutoff: cutoff,
        earliest: addBiz(ship, rule.min),
        latest: addBiz(ship, rule.max)
      };
    }
  
    function fmtDate(d) {
      return (
        WD[d.getDay()] +
        " " +
        ("0" + d.getDate()).slice(-2) +
        "." +
        ("0" + (d.getMonth() + 1)).slice(-2) +
        "."
      );
    }
  
    function fmtCd(ms) {
      var s = Math.max(0, Math.floor(ms / 1000));
      var h = Math.floor(s / 3600);
      var m = Math.floor((s % 3600) / 60);
      return h + " Std. " + ("0" + m).slice(-2) + " Min.";
    }
  
    function isPreorderPage() {
      if (document.querySelector(".preorder-text, .pre-order-text")) return true;
      var bodyClass = document.body.className || "";
      if (/pre[-_]?order/i.test(bodyClass)) return true;
      return false;
    }
  
    function hideOldDelivery() {
      CONFIG.HIDE_SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          var wrap = el.closest(".cart-delivery-date, .cart-delivery-message, .cart-delivery-bar");
          if (wrap) {
            wrap.style.display = "none";
          } else {
            el.style.display = "none";
          }
        });
      });
  
      document.querySelectorAll(".product-stock-block .green-letter").forEach(function (el) {
        var t = (el.textContent || "").trim();
        if (STOCK_TRIM.test(t)) {
          el.textContent = "Auf Lager";
        }
      });
    }
  
    function findAnchor() {
      return (
        document.querySelector(".product-stock-block .green-letter") ||
        document.querySelector(".product-stock-block") ||
        document.querySelector(".additional_payment_block") ||
        document.querySelector(".product-info__buy-buttons")
      );
    }
  
    function ensurePlacement(root) {
      var anchor = findAnchor();
      if (!anchor || !root) return;

      // Already correctly inside the stock block (delivery-timer has no "Auf Lager").
      var stockBlock = document.querySelector(".product-stock-block");
      if (stockBlock && stockBlock.contains(root)) {
        return;
      }

      stockBlock = anchor.closest ? anchor.closest(".product-stock-block") : null;
      if (stockBlock && anchor.classList && anchor.classList.contains("green-letter")) {
        var pickup = stockBlock.querySelector(".kostenlose_abholung");
        var insertAfter = pickup || anchor;
        if (root.parentElement !== stockBlock || root.previousElementSibling !== insertAfter) {
          insertAfter.insertAdjacentElement("afterend", root);
        }
        return;
      }
      if (anchor.classList && anchor.classList.contains("product-stock-block")) {
        if (!anchor.contains(root)) {
          anchor.appendChild(root);
        }
        return;
      }
      if (anchor !== root.previousElementSibling && !anchor.contains(root)) {
        anchor.insertAdjacentElement("afterend", root);
      }
    }
  
    function paint(root, state) {
      var earliest = fmtDate(state.earliest);
      var latest = fmtDate(state.latest);
      var html =
        PARCEL_SVG +
        "Erhalte deine Lieferung zwischen <strong>" +
        earliest +
        "</strong> und <strong>" +
        latest +
        "</strong>";
  
      if (state.beforeCutoff) {
        var cd = fmtCd(state.cutoff - berlinNow());
        html +=
          " — noch <span class=\"bsi29-cd\">" +
          cd +
          "</span> für Versand heute.";
      } else {
        html += ".";
      }
  
      root.innerHTML = html;
      root.setAttribute("data-bsi29-ready", "1");
    }
  
    function updateCountdown(root, state) {
      var cdEl = root.querySelector(".bsi29-cd");
      if (!cdEl) return;
      if (state.beforeCutoff) {
        cdEl.textContent = fmtCd(state.cutoff - berlinNow());
      }
    }
  
    function destroy() {
      if (tickTimer) {
        clearInterval(tickTimer);
        tickTimer = null;
      }
      activeRoot = null;
      lastEarliest = "";
      lastLatest = "";
    }
  
    function render() {
      if (activeRoot && !document.contains(activeRoot)) {
        destroy();
      }
  
      var root = document.getElementById(CONFIG.ROOT_ID);
      if (!root) {
        destroy();
        return;
      }
  
      destroy();
      activeRoot = root;
  
      if (isPreorderPage()) {
        root.remove();
        return;
      }
  
      ensurePlacement(root);
      hideOldDelivery();
  
      var rule = ruleFromRoot(root);
  
      function tick() {
        var state = compute(rule);
        var earliest = fmtDate(state.earliest);
        var latest = fmtDate(state.latest);
        var needsFullPaint =
          earliest !== lastEarliest ||
          latest !== lastLatest ||
          (!state.beforeCutoff && !!root.querySelector(".bsi29-cd"));
  
        if (needsFullPaint) {
          paint(root, state);
          lastEarliest = earliest;
          lastLatest = latest;
        } else if (state.beforeCutoff) {
          updateCountdown(root, state);
        }
      }
  
      tick();
  
      tickTimer = setInterval(function () {
        if (!document.getElementById(CONFIG.ROOT_ID)) {
          destroy();
          return;
        }
        tick();
      }, 1000);
    }
  
    function startHideObserver() {
      if (hideObserver) return;
      hideObserver = new MutationObserver(function () {
        hideOldDelivery();
      });
      var productInfo = document.querySelector(".product-info, .main-product-custom");
      if (productInfo) {
        hideObserver.observe(productInfo, { childList: true, subtree: true, characterData: true });
      }
    }
  
    function startNavObserver() {
      if (navObserver) return;
      navObserver = new MutationObserver(function () {
        var root = document.getElementById(CONFIG.ROOT_ID);
        if (root && root !== activeRoot) {
          render();
        }
      });
      navObserver.observe(document.body, { childList: true, subtree: true });
    }
  
    function boot() {
      if (!document.getElementById(CONFIG.ROOT_ID) && !document.querySelector(".product-info, .main-product-custom")) {
        return;
      }
      hideOldDelivery();
      render();
      startHideObserver();
      startNavObserver();
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
  
    document.addEventListener("shopify:section:load", function () {
      activeRoot = null;
      boot();
    });
    window.addEventListener("pageshow", boot);
  })();
  
